import { DeleteOutlined } from '@ant-design/icons';
import {ConfigProvider, Form, Input, Modal, notification, Popconfirm, Spin, Switch, Tooltip, Transfer, Tree, Typography} from 'antd';
import _ from 'lodash/lodash';
import pluralize from 'pluralize';
import React, { useRef, useState } from 'react';
import ProcessoService from '../../services/ProcessoService';
import LotacoesService from '../../services/LotacoesService';
import ptBr from '../../../pt_BR';


const FORM_FIELDS = ['nome', 'ativo', 'externo', 'sigla'];
const NODE_FIELDS = [...FORM_FIELDS, 'id', 'tipo_ou_assunto', 'parent_id', 'orgaos_blocked'];

function updateTreeData(list, key, children) {
  return list.map((node) => {
    if (node.key === key) {
      return {...node, children};
    } else if (node.children) {
      return {...node, children: updateTreeData(node.children, key, children)};
    }

    return node;
  });
}

function formValuesFromNode(node) {
  return _.pick(node, FORM_FIELDS);
}

const MODAL_ITEM_BASE = {visible: false, loading: false, title: 'title', body: 'body'};
const layout          = {
  labelCol:   {span: 5},
  wrapperCol: {span: 19}
};

const FormTranfer = ({orgaos, orgaosBlockeds = [], assuntoId = null, onOrgaosBlockedsChange = () => {}}) => {
  const [targetKeys, setTargetKeys] = useState(orgaosBlockeds.map(String));
  const [selectedKeys, setSelectedKeys] = useState([]);
  const [loading, setLoading] = useState(false);
  const onChange = (nextTargetKeys, direction, moveKeys) => {
    setSelectedOrgaosBlockedsByAssunto(nextTargetKeys, direction, moveKeys);
  };

  const setSelectedOrgaosBlockedsByAssunto = async (nextTargetKeys, direction, moveKeys) => {
    try {
      setLoading(true);
      const params = {orgaos_blocked: moveKeys};
      if (direction === 'right') {
        await LotacoesService.add_orgaos_blocked_by_assunto(assuntoId, params);
      }

      if (direction === 'left') {
        await LotacoesService.remove_orgaos_blocked_by_assunto(assuntoId, params);
      }

      setTargetKeys(nextTargetKeys);
      onOrgaosBlockedsChange(nextTargetKeys);
    } catch (e) {
      notification.info({
        message:     'Erro',
        description: `${e}`,
        duration:    10,
        placement:   'bottomRight'
      });
    } finally {
      setLoading(false);
    }
  }

  const onSelectChange = (sourceSelectedKeys, targetSelectedKeys) => {
    setSelectedKeys([...sourceSelectedKeys, ...targetSelectedKeys]);
  };

  const filterOption = (inputValue, item) => (
    `${item.title} ${item.description}`.toLowerCase().includes(inputValue.toLowerCase())
  );


  return (

    <ConfigProvider locale={ptBr}>
      <Spin spinning={loading} tip="Aguarde...">
        <Transfer
            listStyle={{width: '100%'}}
            dataSource={orgaos}
            titles={['Órgãos','Excluídos']}
            targetKeys={targetKeys}
            selectedKeys={selectedKeys}
            onChange={onChange}
            onSelectChange={onSelectChange}
            render={item => item.title}
            disabled={loading}
            showSearch
            filterOption={filterOption}
            pagination
            oneWay
        />
      </Spin>
    </ConfigProvider>
  );
};

export default ({initTreeDate = [], orgaos=  []}) => {
  const [treeData, setTreeData]     = useState(loadTreeData(initTreeDate));
  const [expandedKeys, setExpandedKeys] = useState([]);
  const [modalItem, setModalItem]   = useState(MODAL_ITEM_BASE);
  const [orgaosData, setOrgaosData] = useState(orgaos);
  const form                        = useRef(null);
  const currentNode                 = useRef(null);

  function updateNodeData(list, nodeId, attrs) {
    return list.map((node) => {
      if (node.id === nodeId) {
        return configNodeTipo({...node, ...attrs});
      } else if (node.children) {
        return {...node, children: updateNodeData(node.children, nodeId, attrs)};
      }

      return node;
    });
  }

  function buildOrgaosBlockeds(targetKeys) {
    return orgaosData
      .filter((orgao) => targetKeys.includes(String(orgao.key)))
      .map((orgao) => ({id: orgao.key, sigla: orgao.title}));
  }

  const deletarNode = (node) => {
    ProcessoService
      .destroy_tipo(node.id)
      .then((result) => {
        if (result.status === 200) {
          setTreeData((origin) => _.filter(origin, nodeData => nodeData.id !== node.id));
          setExpandedKeys((keys) => keys.filter((key) => key !== node.key));
        }
      }).catch((e) => (
      notification.info({
        message:     'Erro',
        description: `${e}`,
        duration:    10,
        placement:   'bottomRight'
      })
    ));
  };

  function configNodeTipo(node) {
    return {
      ...node,
      icon:  <span
               className={`badge badge-${node.parent_id ? 'warning' : 'primary'} text-uppercase text-white`}>{node.tipo_ou_assunto}</span>,
      title: (
               <div className='d-inline'
                    style={{marginLeft: `${node.parent_id ? '40px' : '15px'}`, lineHeight: '1.90'}}>
                 <Tooltip placement='bottomLeft' title={'clique com o botão direito para editar'}>
                   <strong className='mb-0'>
                     {node.nome}
                   </strong>
                   [<span
                   className={node.ativo ? 'text-success' : 'text-danger'}>{node.ativo ? 'ativo' : 'inativo'}</span>]
                   {node.externo && (
                     <span>[<span className={'text-info'}>externo</span>]</span>
                   )}
                   { (node.tipo_ou_assunto === 'assunto' && node?.orgaos_blocked?.length > 0) && (
                     <span>
                       [
                       <span className={'text-warning'}>
                         {node.orgaos_blocked.map((ele, idx) => <Typography.Text key={idx} type="danger" delete>{ele.sigla}, </Typography.Text>)}
                       </span>
                       ]
                     </span>
                   )

                   }
                   {node.tipo_ou_assunto === 'tipo' && (
                     <span>
                       [
                       <span className={'text-warning'}>
                         {pluralize('assunto', node.assuntos, true)}
                       </span>
                       ]
                     </span>
                   )}
                   {node.assuntos === 0 && (
                     <span>[<span className={'text-danger'}>
                       <Popconfirm title='Tem certeza disso？' okText='Sim' cancelText='Não'
                                   onConfirm={() => deletarNode(node)}>
                        <DeleteOutlined/>
                      </Popconfirm>
                     </span>]</span>
                   )}
                 </Tooltip>
               </div>
             )
    };
  }

  function loadTreeData(data) {
    return data.map((node) => configNodeTipo({...node, tipo_ou_assunto: 'tipo'}));
  }

  function onLoadData({key, children}) {
    return new Promise((resolve) => {
      if (children) {
        resolve();
        return;
      }

      ProcessoService.assuntos(key).then((result) => {
        if (result.status === 200) {
          setTreeData((origin) => updateTreeData(origin, key, result.data.map((node) => configNodeTipo({
            ...node,
            isLeaf:          true,
            parent_id:       key,
            tipo_ou_assunto: 'assunto'
          }))));
        }

        resolve();
      }).catch((e) => (
        notification.info({
          message:     'Erro',
          description: `${e}`,
          duration:    10,
          placement:   'bottomRight'
        })
      ));
    });
  }

  const editItem = ({node}) => {
    const nodeData = _.pick(node, NODE_FIELDS);
    currentNode.current = _.pick(nodeData, ['id', 'nome', 'ativo', 'externo', 'sigla', 'tipo_ou_assunto', 'parent_id']);
    const isAssunto = nodeData.tipo_ou_assunto === 'assunto'
    const orgaosBlockeds = nodeData?.orgaos_blocked?.map(ele => ele.id)
    const body          = (<>
      <Form
        {...layout}
        name='control-hooks'
        initialValues={formValuesFromNode(nodeData)}
        ref={form}
        preserve={false}
      >
        <Form.Item
          label='Sigla'
          name='sigla'
        >
          <Input placeholder={'Sigla'}/>
        </Form.Item>

        <Form.Item
          label='Nome'
          name='nome'
          rules={[{required: true, message: 'Por favor, digite o nome!'}]}
        >
          <Input placeholder={'Nome'}/>
        </Form.Item>

        <Form.Item label='Externo' name='externo' valuePropName='checked'>
          <Switch checkedChildren='ATIVO' unCheckedChildren='INATIVO'/>
        </Form.Item>

        <Form.Item label='Status' name='ativo' valuePropName='checked'>
          <Switch checkedChildren='ATIVO' unCheckedChildren='INATIVO'/>
        </Form.Item>
        {isAssunto && (
          <FormTranfer
            orgaos={orgaosData}
            orgaosBlockeds={orgaosBlockeds}
            assuntoId={nodeData.id}
            onOrgaosBlockedsChange={(targetKeys) => {
              setTreeData((origin) => updateNodeData(origin, nodeData.id, {
                orgaos_blocked: buildOrgaosBlockeds(targetKeys)
              }));
            }}
          />
        )}
      </Form>
    </>);
    setModalItem({...MODAL_ITEM_BASE, title: 'Editar', body, visible: true});
  };

  const updateItemFromModal = async () => {
    const formValues = form.current.getFieldsValue();

    if (form.current.getFieldError('nome').length === 0 &&
      !_.isEqual(formValuesFromNode(currentNode.current), formValues)) {
      setModalItem((current) => ({...current, loading: true}));

      try {
        const response =
                currentNode.current.tipo_ou_assunto === 'assunto' ?
                  (await ProcessoService.editar_assunto(currentNode.current.id, formValues)) :
                  (await ProcessoService.editar_tipo(currentNode.current.id, formValues));
        if (response.status === 200) {
          setTreeData((origin) => updateNodeData(origin, currentNode.current.id, formValues));
          setModalItem(MODAL_ITEM_BASE);
        }
      } catch (e) {
        notification.info({
          message:     'Erro',
          description: `${e}`,
          duration:    10,
          placement:   'bottomRight'
        });
        setModalItem((current) => ({...current, loading: false}));
      }
    } else {
      setModalItem(MODAL_ITEM_BASE);
    }
  };

  return (
    <>
      <Tree
        showLine={{showLeafIcon: false}}
        showIcon
        onRightClick={editItem}
        expandedKeys={expandedKeys}
        onExpand={setExpandedKeys}
        loadData={onLoadData}
        treeData={treeData}/>

      <Modal
        title={modalItem.title}
        mask={false}
        visible={modalItem.visible}
        confirmLoading={modalItem.loading}
        onCancel={() => !modalItem.loading && setModalItem(MODAL_ITEM_BASE)}
        cancelText={'Cancelar'}
        onOk={updateItemFromModal}
        okText={'Editar'}
        destroyOnClose
      >
        <Spin spinning={modalItem.loading} tip="Aguarde...">
          {modalItem.body}
        </Spin>
      </Modal>
    </>
  );
};
